const initRolodexSlideshow = () => {
  function updateRolodexHeight() {
    const slideshows = document.querySelectorAll('.rolodex-card__section');
    if (slideshows.length < 1) return;

    slideshows.forEach(slideshow => {
      const slides = slideshow.querySelectorAll(
        '.uk-slideshow-items .rolodex__slideshow-slide'
      );
      if (slides.length === 0) return;

      const isMobile = window.innerWidth < 546;
      const slideHeights = [];

      if (!isMobile) {
        const slideshowItems = slideshow.querySelector('.uk-slideshow-items');
        if (slideshowItems) slideshowItems.style.height = `unset`;
      }

      slides.forEach(slide => {
        const content = slide.querySelector('.rolodex__slideshow-content');
        if (!content) return;

        slide.style.setProperty('display', 'grid', 'important');
        const minHeight = 100;

        slideHeights.push(content.offsetHeight);

        const contentHeight = slideHeights.length
          ? Math.max(...slideHeights)
          : 0;

        if (contentHeight > minHeight) {
          const slideshowItems = slideshow.querySelector('.uk-slideshow-items');

          if (slideshowItems) {
            slideshowItems.style.height = `${contentHeight}px`;
          }
        }

        slide.removeAttribute('style');
      });
    });
  }

  window.addEventListener('load', updateRolodexHeight);
  window.addEventListener('resize', () => {
    clearTimeout(window.rolodexResizingTimer);
    window.rolodexResizingTimer = setTimeout(updateRolodexHeight, 250);
  });
};

export default initRolodexSlideshow;
